<!--  -->
<template>
  <div class="my-help">
    <loading v-if="loadings"></loading>
    <div class="content">
      <van-list v-model="loading" @load="onLoad" :finished="finished" :finished-text="finishedText" :offset="160">
        <div class="help-list" v-for="(item, index) in list" :key="index">
          <div @click="skip(item)">
            <div class="list-top">
              <div class="time">
                {{ item.addTime | dateFrm('YYYY-MM-DD HH:mm:ss') }}
              </div>
              <div v-if="item.curStatus == '0'">
                <div class="status" v-if="item.handleStatus == '1'">
                  处理中
                  <van-icon name="arrow" slot="right" />
                </div>
                <div class="status" v-if="item.handleStatus == '2'">
                  已处理
                  <van-icon name="arrow" slot="right" />
                </div>
              </div>
              <div class="status" :style="{color:'#787878'}" v-if="item.curStatus == '2'">
                已撤销
                <van-icon name="arrow" slot="right" />
              </div>
            </div>
            <div class="list-line"></div>
            <div class="list-bottm">
              <span>求助事项： {{ item.helpItem }}</span>
            </div>
          </div>
        </div>
      </van-list>
      <div class="nodata" v-show="!noData">
        <van-image :src="noListIcon" width="250px"></van-image>
        <p>暂无我的求助信息</p>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/loading';
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      uid: this.$cookie.get('w_uid'),
      list: [],
      noData: true,
      loading: false,
      loadings: true,
      noListIcon: require('../../assets/img/data_empty.png'),
      finished: false,
      finishedText: '没有更多了...'
    };
  },
  components: {
    Loading,
  },
  created() {
    // this.getData();
  },
  mounted() {
    document.title = '我的求助';
    // console.log('我的求助');
  },
  methods: {
    onLoad() {
      this.getData();
      this.pageNum = this.pageNum + 1;
    },
    getData() {
      this.loading = true;
      console.log(this.uid)
      this.$request.get(`/appserver/v1/help/myHelpList?userId=${this.uid}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then((data) => {
        // delete data.data.data.list;
        if (data.data.ret == 0) {
          // data.data.data = [];
          if (data.data.data !== null) {
            if (data.data.data.list == null) {
              this.loading = false;
              this.loadings = false;
              this.finished = true;
              this.noData = false;

            } else {
              if (data.data.data.list.length == 0) {
                this.noData = false;
                this.loading = false;
                this.finished = true;
              } else {
                this.noData = true;
                this.list = this.list.concat(data.data.data.list);
                this.loading = false;
                if (this.list.length >= data.data.data.pagination.total) {
                  this.finished = true;
                }
              }
              this.loadings = false;
            }
          } else {
            this.loading = false;
            this.loadings = false;
            this.finished = true;
          }
          if (this.list.length > 1) {
            this.finishedText = '没有更多了...';
          }else{
            this.finishedText = '';

          }
        } else {
          this.finished = true;
        }
      }).catch(e => {

      });
    },

    //跳转
    skip(item) {
      this.$router.push({
        path: '/myHelpDetails',
        query: {
          item: JSON.stringify(item),
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.my-help {
  background: #f8f8f8;
  height: 100%;
  /deep/ .van-loading {
    padding-top: 20px;
    text-align: center;
  }
  .content {
    padding: 20px;
    // min-height: 625px;

    .help-list {
      background: #fff;
      font-size: 14px;
      color: #37384d;
      margin-bottom: 20px;
      padding-bottom: 15px;
      // overflow-y: auto;
      .list-top {
        height: 50px;
        font-weight: bold;
        line-height: 50px;
        padding: 0 15px;
        .time {
          float: left;
        }
        .status {
          float: right;
          width: 40px;
          align-items: center;
          color: #2eba73;
          font-size: 12px;
          font-weight: normal;
          position: relative;
          padding-right: 20px;
          i {
            position: absolute;
            // bottom: 0;
            font-size: 13px;
            right: 0px;
            line-height: 49px;
          }
        }
      }
      .list-line {
        width: 90%;
        height: 0.5px;
        background: #e8e8e8;
        margin: 0 auto;
      }
      .list-bottm {
        padding: 15px;
        color: #555959;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        padding-bottom: 0px;
        // margin-bottom: 15px;
      }
    }
  }
  .nodata {
    text-align: center;
    font-size: 16px;
    // margin-top: 50px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    p {
      color: #787878;
      font-size: 12px;
    }
  }
}
</style>
